import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import store from '../miscData/miscData'

Vue.use(Vuex);

export default {
  state: {
    products: {},
    productDataReady: false,
    selectedBranch: null,
    selectedLocation: null,
    selectedService: null,
    selectedProductGroup: null,
  },
  actions: {
    async getMiscData(context, language) {
      let url = "/umbraco/api/ProjectenModule/GetProjecten";
      if (language != "") {
        // add the language to the querystring
        url += "?language=" + language;
      } // else language == "". The default language will be used.

      await axios
        .get(url)
        .then(function (response) {
          context.commit("products", response.data);
          context.commit("productDataReady", true);
        })
        .catch(function (error) {
          // handle error
          context.commit("productDataReady", false);
        })
        .then(function () {
          // always executed
        });
    },
  },

  getters: {
    branchesOptions: (state, getters) => {
      let branchesOptions = [{ value: null, text: getAlleValue() }]
      for (let index = 0; index < getters.branches.length; index++) {
        let value = getters.branches[index];
        branchesOptions.push({ value: value, text: value });
      }

      return branchesOptions;
    },

    locationsOptions: (state, getters) => {
      let locationsOptions = [{ value: null, text: getAlleValue() }]
      for (let index = 0; index < getters.locations.length; index++) {
        let value = getters.locations[index];
        locationsOptions.push({ value: value, text: value });
      }

      return locationsOptions;
    },

    servicesOptions: (state, getters) => {
      let servicesOptions = [{ value: null, text: getAlleValue() }]
      for (let index = 0; index < getters.services.length; index++) {
        let value = getters.services[index];
        servicesOptions.push({ value: value, text: value });
      }

      return servicesOptions;
    },

    productGroupsOptions: (state, getters) => {
      let productGroupsOptions = [{ value: null, text: getAlleValue() }]
      for (let index = 0; index < getters.productGroups.length; index++) {
        let value = getters.productGroups[index];
        productGroupsOptions.push({ value: value, text: value });
      }

      return productGroupsOptions;
    },

    // Returns all the unique branches of the cars in the cars array.
    branches: (state) => {
      let branches = [];
      let products = state.products;
      for (var i = 0; i < products.length; i++) {
        if (products[i].Branches.length > 0) {
          let branches1 = products[i].Branches;
          branches1.forEach((branch) => {
            branches.push(branch);
          });
        }
      }

      // A Set can only contain unique values so duplicates are removed from the array.
      branches.sort(); // Todo directly use Set
      branches = [...new Set(branches)];
      return branches;
    },

    locations: (state) => {
      let locations = [];
      let products = state.products;
      for (var i = 0; i < products.length; i++) {
        if (products[i].Locations.length > 0) {
          let locations1 = products[i].Locations;
          locations1.forEach((location) => {
            locations.push(location);
          });
        }
      }

      // A Set can only contain unique values so duplicates are removed from the array.
      locations.sort(); // Todo directly use Set
      locations = [...new Set(locations)];
      return locations;
    },

    services: (state) => {
      let services = [];
      let products = state.products;
      for (var i = 0; i < products.length; i++) {
        if (products[i].Services.length > 0) {
          let services1 = products[i].Services;
          services1.forEach((service) => {
            services.push(service);
          });
        }
      }

      // A Set can only contain unique values so duplicates are removed from the array.
      services.sort(); // Todo directly use Set
      services = [...new Set(services)];
      return services;
    },

    productGroups: (state) => {
      let productGroups = [];
      let products = state.products;
      for (var i = 0; i < products.length; i++) {
        if (products[i].ProductGroups.length > 0) {
          let productGroups1 = products[i].ProductGroups;
          productGroups1.forEach((productGroup) => {
            productGroups.push(productGroup);
          });
        }
      }

      // A Set can only contain unique values so duplicates are removed from the array.
      productGroups.sort(); // Todo directly use Set
      productGroups = [...new Set(productGroups)];
      return productGroups;
    },

    filteredProducts: function (state) {
      let products = state.products;

      products = state.selectedBranch != null ? products.filter((product) => product.Branches.includes(state.selectedBranch)) : products;
      products = state.selectedLocation != null ? products.filter((product) => product.Locations.includes(state.selectedLocation)) : products;
      products = state.selectedService != null ? products.filter((product) => product.Services.includes(state.selectedService)) : products;
      products = state.selectedProductGroup != null ? products.filter((product) => product.ProductGroups.includes(state.selectedProductGroup)) : products;

      return products;
    },

    // returns true when there are no wonenObjecten in filteredProducts.
    noResults: (state, getters) => {
      if (getters.filteredProducts != undefined) {
        if (getters.filteredProducts.length == 0) {
          return true;
        }
      } else {
        return false;
      }
    },
  },

  mutations: {
    products(state, payload) {
      state.products = payload;
    },
    productDataReady(state, payload) {
      state.productDataReady = payload;
    },
    selectedBranch(state, payload) {
      state.selectedBranch = payload;
    },
    selectedLocation(state, payload) {
      state.selectedLocation = payload;
    },
    selectedService(state, payload) {
      state.selectedService = payload;
    },
    selectedProductGroup(state, payload) {
      state.selectedProductGroup = payload;
    },
  },
};

function getAlleValue() {
  let url = store.state.miscData.OverviewPageURL;
  if (url.startsWith("/en/")) {
    return "All";
  } else {
    return "Alle";
  }
}
